// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23ZM12.5 9.5H10L10 14H8L8 9.5H5.5L9 5L12.5 9.5ZM15 19L11.5 14.5H14V10H16V14.5H18.5L15 19Z"}}]};

const ArrowUpDownCircleFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'arrow-up-down-circle-filled',
    ref,
    icon: element,
  },
));

ArrowUpDownCircleFilledIcon.displayName = 'ArrowUpDownCircleFilledIcon';

export default ArrowUpDownCircleFilledIcon;
